import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import moment from "moment";

import locales from "./locales";
import { ACCEPT_LANGUAGE } from "./locales/acceptedLanguages";
import { updateCountries } from "./utils/data/static/countries";
import { updateLanguages } from "./utils/data/static/languages";

i18n.on("languageChanged", () => {
  const locale = ACCEPT_LANGUAGE[i18n.language] || ACCEPT_LANGUAGE.DEFAULT;
  moment.locale(locale);
  updateCountries(locale);
  updateLanguages(locale);
});

i18n.use(LanguageDetector).init(
  {
    fallbackLng: {
      default: ["en"]
    },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "locale"
    },
    debug: false,
    interpolation: {
      escapeValue: false // not needed for react!!
    },
    resources: locales,
    // react i18next special options (optional)
    react: {
      wait: true,
      withRef: false,
      bindI18n: "languageChanged loaded",
      bindStore: "added removed",
      nsMode: "default"
    }
  },
  err => {
    if (err) {
      console.log("Error initializing i18next");
      console.error(err);
    }
  }
);

export default i18n;
